var map = {
	"./design_2/services": [
		"3960",
		"chunk-b4a0999c",
		"chunk-2abe40d1"
	],
	"./design_2/services/services": [
		"2bda",
		"chunk-b4a0999c",
		"chunk-04afb5f8"
	],
	"./design_2/single-page/home/components/services": [
		"8315",
		"chunk-be87f07c"
	],
	"./design_2/single-page/home/components/services/services": [
		"6b2c",
		"chunk-e27ba16c"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "f86b";
module.exports = webpackAsyncContext;